<template>
    <div id="content">
        <div class="admin-page-header">
            <div>
                <h1 class="admin-page-title">{{ $t('plans.admin.title') }}</h1>
                <p class="admin-page-subtitle" v-if="total">{{ $t('plans.admin.total', { count: total }) }}</p>
            </div>
            <router-link to="/plans/new" class="btn-purple">
                <i class="bi bi-plus-lg"></i>
                <span>{{ $t('plans.admin.createPlan') }}</span>
            </router-link>
        </div>

        <DataTable
            :columns="columns"
            :rows="plans"
            :total="total"
            :totalPages="totalPages"
            :currentPage="currentPage"
            :perPage="perPage"
            @row="rowHandler"
            @goToPage="goToPage"
        />
    </div>
</template>

<script>
import { cycles, opp } from '../../../lib/utils'
import DataTable from '../DataTable.vue'

export default {
    data:() => ({
        plans: [],
        cycles: cycles,
        actions: [],
        total: 0,
        totalPages: 1,
        perPage: opp,
        currentPage: 1
    }),
    components: { DataTable },
    computed: {
        columns() {
            return [
                { key: 'title', value: this.$t('plans.admin.columns.title') },
                { key: 'priceHuman', value: this.$t('plans.admin.columns.price') },
                { key: 'users', value: this.$t('plans.admin.columns.users') }
            ]
        }
    },
    async mounted() {
        this.$emit('setPageTitle', this.$t('plans.admin.title'))

        this.total = await this.getTotal()
        this.plans = await this.getPlans()
    },
    methods: {
        async getTotal() {
            let plans = await this.$api.getPlans()

            return plans?.data?.count ?? 0
        },
        rowHandler(obj) {
            const item = obj.item
            const url = '/plans/' + item.id

            this.$router.push(url)
        },
        async goToPage(page) {
            this.currentPage = page
            this.plans = await this.getPlans()
        },
        async nextPage() {
            if(this.currentPage === Math.ceil(this.total / this.perPage)) return
            this.currentPage++
            this.plans = await this.getPlans()
        },
        async prevPage() {
            if(this.currentPage === 1) return
            this.currentPage--
            this.plans = await this.getPlans()
        },
        async getPlans() {
            let response = await this.$api.getPlans(this.currentPage)
            if(response.result === 'SUCCESS') {
                this.total = response.data.count
                this.totalPages = response.data.totalPages
                return response.data.plans
            } else if(response.result === 'ERROR') {
                this.total = 0
                this.$notify({
                    text: response.msg,
                    type: 'error'
                })
            }
        }
    }
}
</script>

<style scoped>
:deep(.dt-card) {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
:deep(.table) {
    border-collapse: separate;
    border-spacing: 0;
    margin: 0;
}
:deep(.table thead th) {
    background-color: #faf7ff;
    color: #475569;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
    border-bottom: 1px solid #e5e7eb;
    padding: 12px 16px;
}
:deep(.table tbody td) {
    padding: 12px 16px;
    color: #1e293b;
    border-bottom: 1px solid #f1f5f9;
}
:deep(.table tbody tr:hover) {
    background-color: #faf7ff !important;
}
:deep(.pagination .page-item .page-link) {
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #475569;
    border-radius: 8px;
    margin: 0 2px;
    padding: 6px 12px;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
:deep(.pagination .page-item .page-link:hover) {
    background: #faf7ff;
    border-color: #c4b5fd;
    color: #6d28d9;
}
:deep(.pagination .page-item.active .page-link) {
    background: #7c3aed;
    border-color: #7c3aed;
    color: #fff;
}
</style>
